import { render, staticRenderFns } from "./listProjectForm.vue?vue&type=template&id=ab137c10&scoped=true"
import script from "./listProjectForm.vue?vue&type=script&lang=js"
export * from "./listProjectForm.vue?vue&type=script&lang=js"
import style0 from "./listProjectForm.vue?vue&type=style&index=0&id=ab137c10&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab137c10",
  null
  
)

export default component.exports